<nav
  class="fixed top-0 left-0 w-full sm:bg-white sm:shadow transition-all duration-500"
  style="z-index: 100"
  [ngClass]="{
    'bg-transparent': siteStore.$bp().sm && !siteStore.routeMetadata().bigHeader,
    'backdrop-blur-3xl bg-gradient-to-br to-primary-600/70 via-indigo-700/70 from-slate-800/70 ':
      isScrolled() && siteStore.isMobile()
  }"
>
  <!-- <div class="max-w-xl mx-auto"> -->
  <div class="px-4 mx-auto sm:px-6">
    <div class="relative flex justify-between h-16">
      <div class="flex items-center justify-start flex-1 sm:items-stretch">
        <div class="flex items-center flex-shrink-0">
          <a [routerLink]="['/']">
            <app-sm-logo [width]="83" [customClass]="'navbar-logo hidden sm:flex'"></app-sm-logo>
            <app-sm-logo-white
              [width]="83"
              [customClass]="'navbar-logo flex sm:hidden'"
            ></app-sm-logo-white>
          </a>
        </div>
      </div>
      <div class="static inset-y-0 right-0 flex space-x-3 items-center pr-0 sm:inset-auto sm:ml-6">
        <!-- Bank Account Selection Button -->
        <app-bank-account-button></app-bank-account-button>

        <!-- Profile dropdown -->
        <div
          matRipple
          (click)="siteStore.openDrawer.set(true)"
          class="relative !ring-0 sm:!ring-1 !p-0 flex sm:!py-.5 sm:!pr-5 transition-all !rounded-full cursor-pointer sm:!py-0 sm:!pl-0 hoverable-card"
          [ngClass]="{ '!border-none': siteStore.$bp().sm }"
        >
          @if (totalUnread() > 0) {
            <span
              class="absolute -top-1 -right-1 z-10 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white"
            >
              {{ totalUnread() > 99 ? '99+' : totalUnread() }}
            </span>
          }
          <div>
            <app-avatar
              ngClass="cursor-pointer hover:opacity-90"
              [initials]="authStore.userInitials()"
              [border]="true"
              type="button"
              [size]="42"
            ></app-avatar>
          </div>

          <div class="flex-col justify-start hidden ml-2 sm:flex">
            <span class="font-semibold truncate -mb-1 mt-0.5">{{ authStore.userFullName() }}</span>
            <span class="truncate font-light">{{ authStore.user()?.email }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
